module.exports = __webpack_public_path__ + "static/media/Plane_taking_off.9d2fcf14.mp3";